import React from "react";
import { COMPANY } from "../data/site";
import { Phone, MapPin, Mail, Facebook, Linkedin, Youtube, Instagram, Code2, ArrowUpRight } from "lucide-react";

const Footer = () => {
  return (
    <footer className="relative bg-[#14060a] text-amber-50 pt-20 pb-6 overflow-hidden" data-testid="site-footer">
      <div className="absolute -top-40 left-1/3 w-[600px] h-[600px] rounded-full bg-orange-500/15 blur-3xl pointer-events-none" />
      <div className="max-w-7xl mx-auto px-6 relative">
        {/* Big logotype line */}
        <div className="mb-16">
          <div className="font-display text-6xl sm:text-7xl lg:text-8xl font-extrabold text-white leading-[0.9] tracking-tight">
            Built to <span className="text-heat brush">heat.</span>
          </div>
          <div className="font-mono text-xs uppercase tracking-[0.3em] text-amber-300/70 mt-4">
            Quality is our tradition · Since {COMPANY.since}
          </div>
        </div>

        <div className="grid md:grid-cols-4 gap-10 pb-12 border-b border-white/10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-3 mb-5">
              <div className="bg-white rounded-md p-2">
                <img src={COMPANY.logo} alt="logo" className="h-10 w-auto" />
              </div>
              <div>
                <div className="font-display font-extrabold text-xl text-white">ESS BEE HEATERS</div>
                <div className="text-[10px] tracking-[0.3em] text-amber-300/80 font-mono">PRIVATE LIMITED</div>
              </div>
            </div>
            <p className="text-sm text-amber-100/70 leading-relaxed max-w-md">
              Formerly known as{" "}
              <span className="text-amber-300 font-semibold">ESS BEE ELECTRICAL</span>, we have been updated to{" "}
              <span className="text-amber-300 font-semibold">ESS BEE HEATERS PVT. LTD.</span> since{" "}
              {COMPANY.changeYear}. Manufacturing premium industrial heaters and heating elements since{" "}
              {COMPANY.since}.
            </p>
            <div className="flex gap-3 mt-6">
              {[Facebook, Linkedin, Youtube, Instagram].map((Icon, i) => (
                <a
                  key={i}
                  href="#contact"
                  data-testid={`footer-social-${i}`}
                  className="w-10 h-10 rounded-full bg-white/5 border border-white/10 grid place-items-center hover:bg-orange-500 hover:border-orange-500 transition-colors"
                >
                  <Icon className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-display font-bold text-white mb-5 uppercase text-xs tracking-[0.25em] font-mono">Reach Us</h4>
            <ul className="space-y-3 text-sm text-amber-100/80">
              {COMPANY.contacts.map((c) => (
                <li key={c.phone} className="flex items-start gap-2">
                  <Phone className="w-4 h-4 text-orange-400 mt-1 shrink-0" />
                  <a href={`tel:${c.phone}`} className="hover:text-orange-300 link-underline">
                    {c.name}
                    <br />
                    <span className="text-white">{c.phone}</span>
                  </a>
                </li>
              ))}
              <li className="flex items-start gap-2">
                <Mail className="w-4 h-4 text-orange-400 mt-1 shrink-0" />
                <a href={`mailto:${COMPANY.emails[0]}`} className="hover:text-orange-300 break-all link-underline">
                  {COMPANY.emails[0]}
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-display font-bold text-white mb-5 uppercase text-xs tracking-[0.25em] font-mono">Address</h4>
            <p className="text-sm text-amber-100/80 leading-relaxed flex gap-2">
              <MapPin className="w-4 h-4 text-orange-400 mt-1 shrink-0" />
              <span>{COMPANY.address}</span>
            </p>
            <a
              href={COMPANY.catalogueUrl}
              target="_blank"
              rel="noreferrer"
              className="mt-5 inline-flex items-center gap-1.5 text-orange-300 font-semibold text-sm hover:text-orange-200 link-underline"
            >
              Download Catalogue <ArrowUpRight className="w-4 h-4" />
            </a>
          </div>
        </div>

        <div className="mt-6 flex flex-col md:flex-row gap-3 justify-between text-xs text-amber-100/60 font-mono">
          <div>© {new Date().getFullYear()} ESS BEE HEATERS PRIVATE LIMITED. All rights reserved.</div>
          <div className="uppercase tracking-[0.2em]">Quality is our Tradition · An ISO 9001:2015 Certified Company</div>
        </div>

        <div
          data-testid="hrithik-credit"
          className="mt-5 flex items-center justify-center gap-2 text-[11px] text-amber-200/70 font-mono"
        >
          <Code2 className="w-3.5 h-3.5 text-orange-400" />
          <span>
            Created and made by{" "}
            <a
              href={`tel:${COMPANY.contacts[0].phone}`}
              className="text-orange-300 font-bold hover:text-orange-200 link-underline"
            >
              Hrithik Bansal
            </a>
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
